<section *ngIf="!is_previous_sale_closed" class="content">
  <div class="row">
    <div class="col" style="text-align: center;">
      <label style="color: #3835ff; font-size: 30px;">Previous Sale was not closed. Please Close that and order <br>
        <button mat-raised-button style="background: green; color: white;"
          (click)="saleClosedCalled(previous_date)">Close - {{previous_date | date}} Sale</button>
      </label>
    </div>
  </div>
</section>

<section class="content" *ngIf="is_previous_sale_closed">
  <div class="container-fluid" *ngIf="is_today_sale_closed">
    <div class="row">
      <div class="col" style="text-align: center;">
        <label style="color: #3835ff; font-size: 30px;">Today Sale was closed @ {{today_sale_close_details['closed_at'] |
          date}} by {{today_sale_close_details['closed_by']}} <br>
        </label>
      </div>
    </div>
  </div>
  <div class="container-fluid"  *ngIf="!is_today_sale_closed">
    <div *ngIf="!is_counter_selected">
      <div class="card" style="    padding: 24px;">
        <div style="margin-top: 2%;">
          <label style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">Select the counter you
            are going to work today</label>
        </div>
        <div class="row">
          <div class="col-sm-12 col-lg-7 col-md-7">
            <div class="row">
              <div class="border-item col-4" style="font-weight: bold;">Collection Center</div>
              <div class="border-item col-4" style="font-weight: bold;">Counter Name</div>
              <div class="border-item col-4" style="font-weight: bold;">Login users</div>
            </div>
            <div class="row" *ngFor="let center of collection_center">
              <div class="border-item col-4">{{center}}</div>
              <div class="col border-item">
                <div class="row" *ngFor="let counter of counter_list[center]">
                  <div class="col border-item"><button mat-button
                      style="background: aquamarine; border-radius: 15px; margin-top: 10px;"
                      (click)="counterClicked(counter.counter_id)"
                      [disabled]="logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">{{counter['counter_name']}}</button>
                  </div>
                  <div class="col border-item">
                    <span *ngIf="logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">
                      {{logged_user_befere_select_counter[counter.counter_id]['employee_name']}} at
                      {{logged_user_befere_select_counter[counter.counter_id]['start_date_time'] | date: 'shortTime'}}
                    </span>
                    <span *ngIf="!logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">
                      No one
                    </span>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="is_counter_selected">
      <!-- search booth code -->
      <div class="form-row" style="margin-top: 10%; margin-left: 8%;" *ngIf="!is_business_selected">
        <div class="col-sm-6 col-lg-3 col-md-3">
          <label style="font-size: 15px;">Enter Booth Code and Search <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <input type="number" class="form-control" (keydown.enter)="getBusinessDetailsAndProduct()" id="booth_number"
            style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;"
            [(ngModel)]="selected_business_code">
        </div>
        <div class="col-sm-6 col-lg-2 col-md-2" style="margin-left: 12px; margin-top: 4%;">
          <button mat-raised-button color="primary" (click)="getBusinessDetailsAndProduct()" class="button-class"
            style="font-size: 20px; height: 40px;" [disabled]="selected_business_code == null">Search</button>
        </div>
      </div>
      <div class="row">
        <div *ngIf="!is_data_available" class="col-lg-8 col-sm-12">
          <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
          </mat-progress-spinner>
        </div>
        <div class="col-lg-8 col-sm-12" *ngIf="!show_next_page && is_data_available">
          <!-- order -->
          <span *ngIf="is_business_selected">
            <mat-card>
              <div class="row" style="font-size: 22px;font-weight: 500;">
                <div class="col">Selected Product List</div>
                <div class="col">
                  <input type="text" [(ngModel)]="search_code" (keydown.enter)="productCodeSearch()"
                    placeholder="Search By Code" style="border: 1px solid; border-radius: 10px; padding: 4px;">
                </div>
                <div class="col">
                  <button mat-raised-button (click)="productCodeSearch()"
                    [style.background]="search_code == null ? 'lightgray': '#35af60'"
                    style="color: white; font-size: 21px;" [disabled]="search_code == null">Add</button>
                </div>
                <div class="col" style="text-align: center;">
                  <button mat-raised-button (click)="productListingPage()"
                    [style.background]="selected_product_list.length == 0 ? 'lightgray': '#35af60'"
                    style="color: white; font-size: 21px;" [disabled]="selected_product_list.length == 0">Next</button>
                </div>
              </div>
              <div class="row" style="margin-top: 3%;">
                <div class="col">
                  <mat-chip-list #chipList aria-label="product selection">
                    <mat-chip *ngFor="let product of selected_product_list; let product_index=index" [selectable]="true"
                      [removable]="true"
                      (removed)="removeCalled(product_index, product['product_group'], product['product_id'])">
                      {{product['short_name']}}
                      <mat-icon matChipRemove *ngIf="true" style="color:red">cancel</mat-icon>
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
            </mat-card>
            <mat-accordion>
              <mat-expansion-panel *ngFor="let product_group of by_product_group_list; let product_group_index=index"
                style="margin-top: 6px; margin-bottom: 15px; border-radius: 8px;">
                <mat-expansion-panel-header style="padding: 30px;">
                  <mat-panel-title style="font-weight: 500;">
                    {{product_group['name']}}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                  <div class="row" *ngFor="let product of by_product_dict[product_group['id']]; let product_index=index"style="font-size: 15px;" size="6">
                      <div class="col-6" size="10">
                        <p>{{product['short_name']}}</p>
                      </div>

                      <div class="col-4" size="10">
                        <p>{{product['quantity_now']}}</p>
                      </div>

                      <div class="col-2" *ngIf="product['quantity_now'] > 0">
                        <div *ngIf="sale_closed_product_list.includes(product['by_product_id'])">
                          <label>Closed</label>
                        </div>
                        <div *ngIf="!sale_closed_product_list.includes(product['by_product_id'])">
                          <span class="material-icons"
                            style="border: 1px solid; background: green; color: white; border-radius: 25px;cursor: pointer;"
                            *ngIf="!by_product_dict[product_group['id']][product_index]['is_checked']"
                            (click)="addOrRemoveCalled('add', product, product_index)">add</span>
                          <span class="material-icons"
                            style="border: 1px solid; background: red; color: white; border-radius: 25px;cursor: pointer;"
                            *ngIf="by_product_dict[product_group['id']][product_index]['is_checked']"
                            (click)="addOrRemoveCalled('remove', product, product_index)">remove</span>
                        </div>
                      </div>
                      <hr style="width:93%;text-align:left;margin-left:12px">

                    <div class="col-2" *ngIf="product['quantity_now'] < 0"></div>
                  </div>

              </mat-expansion-panel>
            </mat-accordion>
          </span>
        </div>
        <div class="col-lg-8 col-sm-12" *ngIf="show_next_page && is_data_available">
          <mat-card>
            <div class="row">
              <div class="col" style="text-align:right">
                <button mat-raised-button (click)="backToProductSelectPage()"
                  style="border-radius: 25px;background: cornflowerblue; color: white; font-size: 19px;">Back</button>
              </div>
              <div class="col" style="font-size: 20px; font-weight: 500;text-align:center">
                Product List
              </div>
              <div class="col">
                <input type="text" [(ngModel)]="search_code" (keydown.enter)="productCodeSearch()"
                  placeholder="Search By Code" style="border: 1px solid; border-radius: 10px; padding: 4px;">
              </div>
              <div class="col">
                <button mat-raised-button (click)="productCodeSearch()"
                  [style.background]="search_code == null ? 'lightgray': '#35af60'"
                  style="color: white; font-size: 21px;" [disabled]="search_code == null">Add</button>
              </div>
            </div>
            <div class="row" style="font-weight: 600;margin-top: 15px;padding: 11px;">
              <!-- <div class="col-1">S.no</div> -->
              <div class="col-3">Product</div>
              <div class="col-1">Avl. Qty</div>
              <div class="col-2">Req. Qty</div>
              <div class="col-2" style="text-align: right;">Value</div>
              <div class="col-1">SGST</div>
              <div class="col-1">CGST</div>
              <div class="col-2" style="text-align: center;">Total Price</div>
            </div>
            <div class="row" *ngFor="let product of selected_product_list; let product_index=index"
              style="padding: 10px;">
              <!-- <div class="col-1">
                {{product_index+1}}
              </div> -->
              <div class="col-3">
                {{product['short_name']}}<br>
                <i *ngIf="product_price_dict.hasOwnProperty(product['product_id'])">{{product_price_dict[product['product_id']]['mrp']
                  | number : '1.2-4'}}</i>
              </div>
              <div class="col-1">
                <span *ngIf="product_availablity_dict.hasOwnProperty(product['product_id'])">
                  {{product_availablity_dict[product['product_id']]['quantity_now']}}
                </span>
                <span *ngIf="!product_availablity_dict.hasOwnProperty(product['product_id'])">
                  0
                </span>
              </div>
              <div class="col-2">
                <input (keyup)="productQuantityChanged(product_index)" type="number"
                  [(ngModel)]="selected_product_list[product_index]['entered_qty']"
                  style="border: 1px solid;text-indent: 11px;"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57">
              </div>
              <div class="col-2" style="text-align: right;">
                <p>{{product['value'] | number : '1.2-4'}}</p>
              </div>
              <div class="col-1" style="text-align: right;">
                <p>{{product['cgst_value'] | number : '1.2-4' }}</p>
              </div>
              <div class="col-1" style="text-align: right;">
                <p>{{product['sgst_value'] | number : '1.2-4'}}</p>
              </div>
              <div class="col-2" style="text-align: right;">
                <p>{{product['total_price'] | number : '1.2-4'}}</p>
              </div>
            </div>
            <div class="row" style="padding: 10px;">
              <div class="col-10" style="text-align: right;">
                <p>Total price</p>
              </div>
              <div class="col-2" style="text-align: right;">
                <p> {{final_price_before_rounded | number : '1.2-4'}}
                </p>
              </div>
            </div>
            <div class="row" style="padding: 10px; margin-top: -2%;">
              <div class="col-10" style="text-align: right;">
                <p>Rounded Off</p>
              </div>
              <div class="col-2" style="text-align: right; ">
                <p> {{roundoff_value | number : '1.2-4'}}
                </p>
              </div>
            </div>
            <div class="row" style="margin-bottom: 5%; padding: 10px; margin-top: -2%;">
              <div class="col-10" style="text-align: right;">
                <p>Net Amount</p>
              </div>
              <div class="col-2" style="text-align: right; border-top: 1px solid; border-bottom: 1px solid;">
                <p> {{final_price | currency:'INR'}}
                </p>
              </div>
            </div>
            <div class="row" *ngIf="final_price > 0">
              <div class="col text-center">
                <button mat-raised-button (click)="confirmOrder()"
                  style=" background: #1d9a1d; color: white; font-size: 22px;" id="confirm_button">Confirm</button>
              </div>
            </div>
          </mat-card>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-row" *ngIf="is_business_selected">
            <div class="col">
              <label style="font-size: 15px;">Enter Booth Code and Search <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <input type="number" class="form-control" (keydown.enter)="getBusinessDetailsAndProduct()"
                id="booth_number" data-date-inline-picker="true"
                style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;font-size: 20px;"
                [(ngModel)]="selected_business_code">
            </div>
            <div class="col-3" style="margin-left: 12px; margin-top: 8%">
              <button mat-raised-button color="primary" (click)="getBusinessDetailsAndProduct()" class="button-class"
                style="font-size: 20px;" [disabled]="selected_business_code == null">Search</button>
            </div>
          </div>
          <div class="row" *ngIf="is_business_selected">
            <div class="col">
              {{booth_details['agent_name'] }}
            </div>
            <div class="col-4">
              <b>Booth Code:</b> {{booth_details['booth_code']}}
            </div>
            <div class="col-4">
              {{booth_details['booth_zone']}} Zone
            </div>
          </div>
          <div class="row" *ngIf="is_business_selected">
            <div class="col-3">
              {{booth_details['agent_mobile']}}
            </div>
            <!-- <div class="col">
              Mor Route - {{booth_details['mor_route_name'] | slice: 0: -4}}
            </div>
            <div class="col">
              Eve Route - {{booth_details['eve_route_name'] | slice: 0: -4}}
            </div> -->
          </div>
          <div style="background: #efeeec; padding: 10px; color: gray;overflow: auto;  height: 600px;">
            <div class="row">
              <div class="col" style="text-align: center;">
                <button style="background: #e13333; color: white; margin-bottom: 3%;" mat-raised-button
                  (click)="saleClosedCalled(today_date_from_server)">Close Today Sale <i
                    class="material-icons" style="margin-top: -3%; color: yellow;">warning</i></button>
              </div>
            </div>
            <div class="row">
              <div class="col" style="text-align: center; font-size: 22px;">
                {{counter_name}} , {{today_date_time | date: 'EEEE, MMM d'}}<br>
              </div>
            </div>
            <div class="row" style="font-size: 18px;">
              <div class="col" style="text-align: center;">
                Total : {{total_amount_in_counter | currency: 'INR'}}
              </div>
              <div class="col-4">
                {{total_booth_count}} Ordered
              </div>
              <!-- <div class="col-3">
                <button mat-button (click)="openZoneWiseCountCliked()" class="button-class"
                  style="font-size: small; height: 30px;">Pending</button> -->
            </div>
            <hr style="background: white;">
            <div class="row" style="font-size: 20px; color: #6fbebe; margin-left: 0%;">
              <div class="col-4">B. code</div>
              <div class="col-4">Amount</div>
              <div class="col-4">Ord Date</div>
            </div>
            <div class="row" *ngFor="let user of login_users" style="font-size: 15px;">
              <div class="col-12" style="margin-bottom: 10px;">
                <div class="row">
                  <div class="col"><span style="font-weight: bold;">{{user['employee_name']}}</span><span
                      style="font-style: italic;">
                      ({{user['login_time']| date: 'shortTime'}} to <span
                        *ngIf="user.logout_time != 0 ">{{user['logout_time'] | date: 'shortTime'}}</span><span
                        *ngIf="user.logout_time == 0 ">Now</span> )
                    </span></div>
                </div>
              </div>
              <div class="col-12">
                <span *ngIf="sale_group_data.hasOwnProperty(user.login_id)">
                  <div class="row" *ngFor="let sale_data of sale_group_data[user.login_id]; let index=index"
                    style="margin-bottom: 10px !important; color: #6fbebe; margin-left: 0%;">
                    <!-- <div class="col-1"></div> -->
                    <div class="col-4" style="font-size: 13px;"> {{index + 1}}. {{sale_data['business_code']}} -
                      {{sale_data['agent_first_name'] | slice :
                      0:6 }}</div>
                    <div class="col-3" style="text-align: right!important;">
                      {{sale_data['total_cost'] | currency: 'INR'}}</div>
                    <div class="col-3">{{sale_data['ordered_date'] | date}}
                    </div>
                    <div class="col-2">
                      <i style="cursor: pointer;" class="material-icons"
                        (click)="deleteSaleClicked(sale_data['by_sale_group'])">delete</i>
                    </div>
                  </div>
                </span>
                <div *ngIf="!sale_group_data.hasOwnProperty(user.login_id)"
                  style="text-align: center; margin-bottom: 10px;">No booth order till now</div>
              </div>
              <div class="col-12">
                <hr style="background: white;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
